import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

export default function Connexion() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [focusedField, setFocusedField] = useState(null);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setError("");
    try {
      const res = await fetch("https://senutour.com/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
    if (data.user.role === "admin") {
  navigate("/admin");
} else if (data.user.role === "chauffeur") {
  navigate("/chauffeur");
} else if (data.user.role === "bailleur") {
  navigate("/bailleur");
} else if (data.user.role === "restaurateur") {
  navigate("/restaurateur");
} else if (data.user.role === "guide") {
  navigate("/guide");
} else if (data.user.role === "artisan") {
  navigate("/artisan");
} else if (data.user.role === "loueur") {
  navigate("/loueur");
} else if (data.user.role === "loisir") {
  navigate("/dashboard/loisir");
} else {
  navigate("/");
}
    } catch (err) {
      setError(err.message);
    }
  };
  const inputStyle = (field) => ({
    width: "100%",
    padding: "13px 18px 13px 42px",
    border: `2px solid ${focusedField === field ? "#C4441A" : "#E8DCC8"}`,
    borderRadius: 10,
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: 14,
    color: "#1C1008",
    background: "white",
    outline: "none",
    transition: "border-color .25s, box-shadow .25s",
    boxSizing: "border-box",
    boxShadow: focusedField === field ? "0 0 0 3px rgba(196,68,26,0.10)" : "none",
  });

 const stats = [
  { val: "100%", label: "Prestataires locaux" },
  { val: "0%",   label: "Commission au lancement" },
  { val: "3",    label: "Villes couvertes" },
  { val: "🇸🇳",  label: "Fait au Sénégal" },
];
  return (
  <>
  <Navbar />
    <div style={{
      fontFamily: "'Space Grotesk', sans-serif",
      background: "#FAF5EC",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px 16px",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        .btn-submit { background: #C4441A; transition: background .2s, transform .2s; }
        .btn-submit:hover { background: #A03614; transform: translateY(-1px); }
        .btn-social:hover { background: #F2E4C8 !important; }
        .eye-btn:hover { color: #C4441A !important; }
        .link-auth { color: #C4441A; text-decoration: none; font-weight: 600; transition: color .2s; }
        .link-auth:hover { color: #A03614; }
        .link-forgot { color: #C4441A; text-decoration: none; font-size: 13px; font-weight: 500; transition: color .2s; }
        .link-forgot:hover { color: #A03614; }
        @media (max-width: 767px) {
          .auth-card { flex-direction: column-reverse !important; }
          .auth-right-panel { width: 100% !important; padding: 32px 24px !important; }
          .auth-left-panel { padding: 32px 24px !important; }
          .stats-grid-2 { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>

      <div className="auth-card" style={{
        width: "100%",
        maxWidth: 900,
        background: "white",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 4px 40px rgba(28,16,8,0.10)",
        display: "flex",
        minHeight: 580,
      }}>

        {/* ── PANNEAU GAUCHE (formulaire) ── */}
        <div className="auth-left-panel" style={{
          flex: 1,
          background: "#FAF5EC",
          padding: "48px 40px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}>
          <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(22px,3vw,28px)", fontWeight:800, color:"#1C1008", margin:"0 0 4px" }}>
            Bon retour !
          </h1>
          <p style={{ fontSize:14, color:"#7A5A3A", margin:"0 0 28px" }}>
            Connectez-vous pour continuer votre aventure
          </p>

          {/* Email */}
          <div style={{ marginBottom:14 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:5 }}>
              Adresse email
            </label>
            <div style={{ position:"relative" }}>
              <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </span>
              <input
                type="email" name="email" placeholder="aminata@exemple.com"
                value={formData.email} onChange={handleChange}
                onFocus={() => setFocusedField("email")}
                onBlur={() => setFocusedField(null)}
                style={inputStyle("email")}
              />
            </div>
          </div>

          {/* Mot de passe */}
          <div style={{ marginBottom:8 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#7A5A3A", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:5 }}>
              Mot de passe
            </label>
            <div style={{ position:"relative" }}>
              <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4"/>
                </svg>
              </span>
              <input
                type={showPassword ? "text" : "password"}
                name="password" placeholder="Votre mot de passe"
                value={formData.password} onChange={handleChange}
                onFocus={() => setFocusedField("password")}
                onBlur={() => setFocusedField(null)}
                style={{ ...inputStyle("password"), paddingRight: 44 }}
              />
              <button
                type="button"
                className="eye-btn"
                onClick={() => setShowPassword(!showPassword)}
                style={{ position:"absolute", right:13, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#8B5E3C", display:"flex", padding:0 }}
                aria-label="Afficher le mot de passe"
              >
                {showPassword ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mot de passe oublié */}
          <div style={{ textAlign:"right", marginBottom:24 }}>
            <Link to="/forgot-password" className="link-forgot">
              Mot de passe oublié ?
            </Link>
          </div>

          {/* Bouton connexion */}
          {error && (
  <div style={{ background:"rgba(196,68,26,.08)", border:"1.5px solid rgba(196,68,26,.2)", borderRadius:8, padding:"12px 16px", marginBottom:16 }}>
    <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, color:"#C4441A", margin:0 }}>
      ⚠️ {error}
    </p>
  </div>
)}
          <button
  type="button"
  className="btn-submit"
  onClick={handleLogin}
  style={{
    width: "100%", padding: "14px", color: "white",
    border: "none", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif",
    fontSize: 15, fontWeight: 700, cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
    boxShadow: "0 8px 20px rgba(196,68,26,0.30)",
  }}
>
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
  </svg>
  Se connecter
</button>
          {/* Séparateur */}
          <div style={{ display:"flex", alignItems:"center", gap:10, margin:"20px 0" }}>
            <div style={{ flex:1, height:1, background:"#E8DCC8" }} />
            <span style={{ fontSize:12, color:"#B89A7A" }}>ou continuer avec</span>
            <div style={{ flex:1, height:1, background:"#E8DCC8" }} />
          </div>

          {/* Boutons sociaux */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <button type="button" className="btn-social" style={{
              display:"flex", alignItems:"center", justifyContent:"center", gap:8,
              border:"2px solid #E8DCC8", borderRadius:10, padding:"12px",
              background:"white", cursor:"pointer", fontSize:13, fontWeight:600, color:"#1C1008",
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Google
            </button>
            <button type="button" className="btn-social" style={{
              display:"flex", alignItems:"center", justifyContent:"center", gap:8,
              border:"2px solid #E8DCC8", borderRadius:10, padding:"12px",
              background:"white", cursor:"pointer", fontSize:13, fontWeight:600, color:"#1C1008",
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#1877F2">
                <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.514c-1.491 0-1.956.93-1.956 1.886v2.254h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
              </svg>
              Facebook
            </button>
          </div>

          {/* Lien inscription */}
          <p style={{ textAlign:"center", fontSize:13, color:"#7A5A3A", marginTop:20 }}>
            Pas encore de compte ?{" "}
            <Link to="/inscription" className="link-auth">S'inscrire</Link>
          </p>
        </div>

        {/* ── PANNEAU DROIT décoratif ── */}
        <div className="auth-right-panel" style={{
          width: "42%",
          background: "#C4441A",
          padding: "48px 36px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
        }}>
          {/* Cercles décoratifs */}
          <div style={{ position:"absolute", width:300, height:300, borderRadius:"50%", border:"50px solid rgba(255,255,255,0.07)", bottom:-100, right:-100 }} />
          <div style={{ position:"absolute", width:160, height:160, borderRadius:"50%", border:"30px solid rgba(255,255,255,0.05)", top:-40, left:-40 }} />

          {/* Logo */}
          <div style={{ position:"relative", zIndex:1, display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:"rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center" }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M12 2C8 6 4 8 4 14a8 8 0 0 0 16 0c0-6-4-8-8-12z"/>
              </svg>
            </div>
            <span style={{ fontFamily:"'Fraunces',serif", fontSize:20, fontWeight:800, color:"white", letterSpacing:"-0.5px" }}>
              Senu<span style={{ color:"rgba(255,255,255,0.5)" }}>Tour</span>
            </span>
          </div>

          {/* Citation */}
          <div style={{ position:"relative", zIndex:1 }}>
            <div style={{ fontFamily:"'Fraunces',serif", fontSize:64, color:"rgba(255,255,255,0.2)", lineHeight:1, marginBottom:4 }}>"</div>
            <p style={{ fontFamily:"'Fraunces',serif", fontSize:20, fontWeight:700, color:"white", lineHeight:1.4, marginBottom:12 }}>
              Le Sénégal vous attend, teranga oblige.
            </p>
            <p style={{ fontSize:13, color:"rgba(255,255,255,0.65)", lineHeight:1.7 }}>
              De Dakar à la Casamance, de Saint-Louis au Sine-Saloum — chaque voyage commence ici.
            </p>
          </div>

          {/* Stats */}
          <div className="stats-grid-2" style={{ position:"relative", zIndex:1, display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            {stats.map((s, i) => (
              <div key={i} style={{
                background: "rgba(255,255,255,0.10)",
                borderRadius: 10, padding: "14px",
                textAlign: "center",
              }}>
                <div style={{ fontFamily:"'Fraunces',serif", fontSize:22, fontWeight:800, color:"white" }}>{s.val}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.60)", marginTop:3 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
    <Footer />
  </>
  );
}